/* eslint-disable vue/component-definition-name-casing */
import Vue from 'vue'
import Page from '~/components/Template/Page'

import backgroundImage from '~/components/Layouts/BackgroundImage'
import columnLayout from '~/components/Layouts/ColumnLayout'
// import imageBlok from '~/components/Layouts/Image' DELETE
import gridLayout from '~/components/Layouts/GridLayout'
import gridItem from '~/components/Layouts/GridItem'
import wrapper from '~/components/Layouts/Wrapper'
import vector from '~/components/Layouts/Vector'
import rowLayout from '~/components/Layouts/RowLayout'
import flexLayout from '~/components/Layouts/FlexLayout'
import cardGroup from '~/components/Layouts/CardGroup'
import sectionCopy from '~/components/Layouts/SectionCopy'
import ApAspot from '~/components/Page/ApAspot'
import SummitBSpotSwiper from '~/components/Page/SummitBSpotSwiper'
import PricingAspot from '~/components/Page/PricingAspot'
import PricingNavigation from '~/components/Page/PricingNavigation'
import PricingNavigationItem from '~/components/Page/PricingNavigation/PricingNavigationItem'
import PricingWhatsIncluded from '~/components/Page/PricingWhatsIncluded'
import PricingCardGroup from '~/components/Page/PricingCardGroup'
import PricingCard from '~/components/Page/PricingCard'
import PricingTable from '~/components/Page/PricingTable'
import KnowledgeBaseCard from '~/components/Page/KnowledgeBaseCard'
import SummitAspot from '~/components/Page/SummitAspot'
import KimberlySpeaker from '~/components/Animated/KimberlySpeaker'
import Flair from '~/components/Animated/Flair'
import EPAspot from '~/components/Modules/Aspots/EPAspot'
import RatingsAspot from '~/components/Modules/Aspots/RatingsAspot'
import FacultyAspot from '~/components/Modules/Aspots/FacultyAspot'
import EquityRatingAspot from '~/components/Modules/Aspots/EquityRatingAspot'
import HPBAspot from '~/components/Modules/Aspots/HPBAspot'
import ESGAspot from '~/components/Modules/Aspots/ESGAspot'
import LeaderboardAspot from '~/components/Modules/Aspots/LeaderboardAspot'
import SliderLayout from '~/components/Modules/Layouts/SliderLayout'
import HPBPollDiagram from '~/components/Modules/Custom/HPBPollDiagram'
import EquityDiagram from '~/components/Modules/Diagrams/EquityDiagram'
import ResearchLoopDiagram from '~/components/Modules/Diagrams/ResearchLoopDiagram'
import TwoColumnBentoBox from '~/components/Modules/Diagrams/TwoColumnBentoBox'
import CardTestimony from '~/components/Modules/Cards/Testimony'
import CardDirectory from '~/components/Modules/Cards/Directory'
import CardCta from '~/components/Modules/Cards/Cta'
import EmailCapture from '~/components/Modules/Forms/EmailCapture'
import HbsptEmail from '~/components/Modules/Forms/HbsptEmail'
import Testimonies from '~/components/Modules/Custom/Testimonies'
import FAQ from '~/components/Modules/Custom/FAQ'
import ContactInfo from '~/components/Modules/Custom/ContactInfo'
import JourneyCarousel from '~/components/Modules/Custom/JourneyCarousel'
import TestimonySlider from '~/components/Modules/Custom/TestimonySlider'
import JourneyCarouselItem from '~/components/Modules/Custom/JourneyCarouselItem'
import PinContainer from '~/components/Modules/Custom/PinContainer'
import PinCard from '~/components/Modules/Custom/PinCard'
import LicensingScroll from '~/components/Modules/Custom/LicensingScroll'
import ProductStepDiagram from '~/components/Modules/Custom/ProductStepDiagram'
import ShowCaseCarousel from '~/components/Modules/Custom/ShowCaseCarousel'
import OverFlowImage from '~/components/Modules/Custom/OverFlowImage'
import TabGroup from '~/components/Modules/Custom/TabGroup'
import VerticalTabGroup from '~/components/Modules/Custom/VerticalTabGroup'
import PricingComponent from '~/components/Modules/Custom/PricingComponent'
import CommunityNetwork from '~/components/Modules/Custom/CommunityNetwork'
import WellApHeroNetwork from '~/components/Modules/Custom/WellApHeroNetwork'
import ParallaxImageWithIcons from '~/components/Modules/Custom/ParallaxImageWithIcons'
import VideoBackground from '~/components/Modules/Custom/VideoBackground'
import BrushArt from '~/components/Modules/Custom/BrushArt'
import LogosTabGroup from '~/components/Modules/Custom/LogosTabGroup'
import CarouselCard from '~/components/Modules/Custom/CarouselCard'
import CarouselCardTab from '~/components/Modules/Custom/CarouselCardTab'
import ESGStats from '~/components/Modules/Custom/ESGStats'
import ESGNetwork from '~/components/Modules/Custom/ESGNetwork'
import ESGCarousel from '~/components/Modules/Custom/ESGCarousel'
import PollWidget from '~/components/Modules/Custom/PollWidget'
import LeaderboardScores from '~/components/Modules/Custom/LeaderboardScores'
import LeaderboardMap from '~/components/Modules/Custom/LeaderboardMap'
import LeaderboardMapScore from '~/components/Modules/Custom/LeaderboardMapScore'
import LeaderboardAwardCollage from '~/components/Modules/Custom/LeaderboardAwardCollage'
import LeaderboardBarChart from '~/components/Modules/Custom/LeaderboardBarChart'
import LeaderboardStrategiesTable from '~/components/Modules/Custom/LeaderboardStrategiesTable'
import LeaderboardTrends from '~/components/Modules/Custom/LeaderboardTrends'
import SummitTestimonyCarousel from '~/components/Modules/Custom/SummitTestimonyCarousel'
import Section from '~/components/Modules/Common/Section'
import SectionLayout from '~/components/Modules/Common/SectionLayout'
import BackgroundImage from '~/components/Modules/Common/BackgroundImage'
import ResponsiveBackgroundImage from '~/components/Modules/Common/ResponsiveBackgroundImage'
import Heading from '~/components/Modules/Common/Heading'
import SubHead from '~/components/Modules/Common/SubHead'
import RichText from '~/components/Modules/Common/RichText'
import RichTextWithIcon from '~/components/Modules/Common/RichTextWithIcon'
import Grid from '~/components/Modules/Common/Grid'
import Stat from '~/components/Modules/Common/Stat'
import CallToAction from '~/components/Modules/Common/CallToAction'
import IconGridItem from '~/components/Modules/Common/IconGridItem'
import Modal from '~/components/Modules/Common/Modal'
import Column from '~/components/Modules/Common/Column'
import NuxtImage from '~/components/Modules/Common/NuxtImage'
import NuxtImgWithText from '~/components/Modules/Common/NuxtImgWithText'
import SimpleText from '~/components/Modules/Common/SimpleText'
import BackgroundLayer from '~/components/Modules/Common/BackgroundLayer'
import Video from '~/components/Modules/Common/Video'
import Row from '~/components/Modules/Common/Row'
import CardSide from '~/components/Modules/Common/CardSide'
import AvatarSimple from '~/components/Modules/Common/AvatarSimple'
import CTA from '~/components/Modules/Common/CTA'
import Carousel from '~/components/Modules/Common/Carousel'
import CardNews from '~/components/Modules/Common/CardNews'
import GridFeatured from '~/components/Modules/Common/GridFeatured'
import ColumnLayout from '~/components/Modules/Common/ColumnLayout'
import SectionCopy from '~/components/Modules/Common/SectionCopy'
import CardLayout from '~/components/Modules/Common/CardLayout'
import CardOrganization from '~/components/Modules/Common/CardLayout/organization'
import RowLayout from '~/components/Modules/Common/RowLayout'
import ExploreLayout from '~/components/Modules/Common/ExploreLayout'
import CardBuilder from '~/components/Modules/Common/CardLayout/builder'
import ImageLayout from '~/components/Modules/Common/ImageLayout'
import Socials from '~/components/Modules/Common/Socials'
import Icon from '~/components/Modules/Common/Icon'
import ESGTriangleDiagram from '~/components/Modules/Animated/ESGTriangleDiagram'
import ESGBalanceIcons from '~/components/Modules/Animated/ESGBalanceIcons'
import ESGSeal from '~/components/Modules/Animated/ESGSeal'
import HomeASpot from '~/components/Sections/Home/ASpot'
import Orgs from '~/components/Sections/Home/Orgs'
import Diagram from '~/components/Sections/Home/Diagram'
import ESG from '~/components/Sections/Home/ESG'
import HealthSafety from '~/components/Sections/Home/HealthSafety'
import Projects from '~/components/Sections/Home/Projects'
import Testimony from '~/components/Sections/Home/Testimony'
import Media from '~/components/Sections/Home/Media'
import Newsletter from '~/components/Sections/Home/Newsletter'
import Science from '~/components/Sections/Home/Science'
import HomeVideo from '~/components/Sections/Home/Video'
import WellAtScaleASpot from '~/components/Sections/WAS/ASpot'
import Chart from '~/components/Sections/WAS/Chart'
import Logos from '~/components/Sections/WAS/Logos'
import Performance from '~/components/Sections/WAS/Performance'
import Reports from '~/components/Sections/WAS/Reports'
import Roadmap from '~/components/Sections/WAS/Roadmap'
import Solutions from '~/components/Sections/WAS/Solutions'
import FrequentlyAskedQuestions from '~/components/Sections/WAS/FAQ'
import Contact from '~/components/Sections/WAS/Contact'
import Connect from '~/components/Sections/WAS/Connect'
import WhyWellASpot from '~/components/Sections/WW/ASpot'
import Platform from '~/components/Sections/WW/Platform'
import Results from '~/components/Sections/WW/Results'
import Demand from '~/components/Sections/WW/Demand'
import Leadership from '~/components/Sections/WW/Leadership'
import Next from '~/components/Sections/WW/Next'

/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////// V2 //////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////
import sectionLayout from '~/components/V2/legacy/SectionLayout'
import layout from '~/components/V2/legacy/Layout'
import imageLayout from '~/components/V2/legacy/ImageLayout'
import imageSource from '~/components/V2/legacy/ImageSource'
import cardCopy from '~/components/V2/legacy/CardCopy'
import container from '~/components/V2/legacy/Container'
import moduleBlock from '~/components/V2/Layouts/ModuleBlock'
import sectionBlock from '~/components/V2/Layouts/SectionBlock'
import masonryLayout from '~/components/V2/Layouts/MasonryLayout'
import buttonGroup from '~/components/V2/Layouts/ButtonGroup'
import tabGroup from '~/components/V2/Layouts/TabGroup'
import background from '~/components/V2/Layouts/Background'
import carouselBlock from '~/components/V2/Layouts/CarouselBlock'
import block from '~/components/V2/Layouts/Block'
import videoBlock from '~/components/V2/Layouts/VideoBlock'
import imageBlock from '~/components/V2/Layouts/ImageBlock'
import verticalTabGroup from '~/components/V2/Layouts/VerticalTabGroup'
import cardBlock from '~/components/V2/Layouts/CardBlock'
import subhead from '~/components/V2/Components/Subhead'
import heading from '~/components/V2/Components/Heading'
import richtext from '~/components/V2/Components/Richtext'
import AspectRatioBox from '~/components/V2/Components/AspectRatioBox'
import eventbrite from '~/components/V2/Components/Eventbrite'
import iFrame from '~/components/V2/Components/Iframe'
import cta from '~/components/V2/Components/CTA'
import faq from '~/components/V2/Components/FAQ'
import modal from '~/components/V2/Components/Modal'
import divider from '~/components/V2/Components/Divider'
import linkLayout from '~/components/V2/Components/LinkLayout'
import parallaxImage from '~/components/V2/Components/ParallaxImage'
import HbsptForm from '~/components/V2/Components/HbsptForm'
import BlockText from '~/components/V2/Components/BlockText'

import SVGImage from '~/components/V2/SubComponents/SVGImage'

// page specific
import LearningCommunityAspot from '~/components/V2/Page/well-forum/LearningCommunityAspot'
import HsrAspot from '~/components/V2/Page/hsr/HsrAspot'
import ConferenceAspot from '~/components/V2/Page/conference/ConferenceAspot'
import RegionalMapWithAvatars from '~/components/V2/Page/why-well/RegionalMapWithAvatars'
import RechargeAspot from '~/components/V2/Page/recharge/RechargeAspot'
import RechargeFlagship from '~/components/V2/Page/recharge/RechargeFlagship'
import RechargeGeoCard from '~/components/V2/Page/recharge/RechargeGeoCard'
import RechargeSpeakerCard from '~/components/V2/Page/recharge/RechargeSpeakerCard'
import RechargeSocials from '~/components/V2/Page/recharge/RechargeSocials'
import RechargeWellDifference from '~/components/V2/Page/recharge/RechargeWellDifference'
// animated
import animatedSeal from '~/components/V2/Animated/AnimatedSeal'
import textRotator from '~/components/V2/Animated/TextRotator'

import ChartModule from '~/components/ChartModule'

Vue.component('Page', Page)
Vue.component('sectionLayout', sectionLayout)
Vue.component('moduleBlock', moduleBlock)
Vue.component('sectionBlock', sectionBlock)
Vue.component('layout', layout)
Vue.component('imageLayout', imageLayout)
Vue.component('masonryLayout', masonryLayout)
Vue.component('sectionCopy', sectionCopy)
Vue.component('heading', heading)
Vue.component('subhead', subhead)
Vue.component('richtext', richtext)
Vue.component('AspectRatioBox', AspectRatioBox)
Vue.component('eventbrite', eventbrite)
Vue.component('iFrame', iFrame)
Vue.component('cta', cta)
Vue.component('buttonGroup', buttonGroup)
Vue.component('tabGroup', tabGroup)
Vue.component('gridLayout', gridLayout)
Vue.component('modal', modal)
Vue.component('imageSource', imageSource)
Vue.component('faq', faq)
Vue.component('cardCopy', cardCopy)
Vue.component('divider', divider)
Vue.component('linkLayout', linkLayout)
Vue.component('container', container)
Vue.component('background', background)
Vue.component('block', block)
Vue.component('carouselBlock', carouselBlock)
Vue.component('verticalTabGroup', verticalTabGroup)
Vue.component('videoBlock', videoBlock)
Vue.component('cardBlock', cardBlock)
Vue.component('imageBlock', imageBlock)
Vue.component('parallaxImage', parallaxImage)
Vue.component('HbsptForm', HbsptForm)
Vue.component('LearningCommunityAspot', LearningCommunityAspot)
Vue.component('HsrAspot', HsrAspot)
Vue.component('ConferenceAspot', ConferenceAspot)
Vue.component('RegionalMapWithAvatars', RegionalMapWithAvatars)
Vue.component('RechargeAspot', RechargeAspot)
Vue.component('RechargeFlagship', RechargeFlagship)
Vue.component('animatedSeal', animatedSeal)
Vue.component('textRotator', textRotator)
Vue.component('SVGImage', SVGImage)

Vue.component('BlockText', BlockText)
Vue.component('RechargeGeoCard', RechargeGeoCard)
Vue.component('RechargeSpeakerCard', RechargeSpeakerCard)
Vue.component('RechargeSocials', RechargeSocials)
Vue.component('RechargeWellDifference', RechargeWellDifference)
/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////

Vue.component('backgroundImage', backgroundImage)
Vue.component('columnLayout', columnLayout)
// Vue.component('imageBlok', imageBlok) DELETE
Vue.component('wrapper', wrapper)
Vue.component('vector', vector)
Vue.component('gridItem', gridItem)
Vue.component('rowLayout', rowLayout)
Vue.component('flexLayout', flexLayout)
Vue.component('cardGroup', cardGroup)
Vue.component('ApAspot', ApAspot)
Vue.component('PricingAspot', PricingAspot)
Vue.component('PricingNavigation', PricingNavigation)
Vue.component('PricingNavigationItem', PricingNavigationItem)
Vue.component('PricingWhatsIncluded', PricingWhatsIncluded)
Vue.component('PricingCardGroup', PricingCardGroup)
Vue.component('PricingCard', PricingCard)
Vue.component('PricingTable', PricingTable)
Vue.component('KnowledgeBaseCard', KnowledgeBaseCard)
Vue.component('SummitBSpotSwiper', SummitBSpotSwiper)
Vue.component('KimberlySpeaker', KimberlySpeaker)
Vue.component('Flair', Flair)
Vue.component('EPAspot', EPAspot)
Vue.component('RatingsAspot', RatingsAspot)
Vue.component('FacultyAspot', FacultyAspot)
Vue.component('EquityRatingAspot', EquityRatingAspot)
Vue.component('EquityChart', EquityDiagram)
Vue.component('HPBAspot', HPBAspot)
Vue.component('ResearchLoopDiagram', ResearchLoopDiagram)
Vue.component('TwoColumnBentoBox', TwoColumnBentoBox)
Vue.component('Section', Section)
Vue.component('Heading', Heading)
Vue.component('SubHead', SubHead)
Vue.component('RichText', RichText)
Vue.component('RichTextWithIcon', RichTextWithIcon)
Vue.component('TestimonyCard', CardTestimony)
Vue.component('Grid', Grid)
Vue.component('Stat', Stat)
Vue.component('DirectoryCard', CardDirectory)
Vue.component('CardCta', CardCta)
Vue.component('Testimonies', Testimonies)
Vue.component('CallToAction', CallToAction)
Vue.component('IconGridItem', IconGridItem)
Vue.component('Modal', Modal)
Vue.component('Faq', FAQ)
Vue.component('Column', Column)
Vue.component('Img', NuxtImage)
Vue.component('ContactInfo', ContactInfo)
Vue.component('SimpleText', SimpleText)
Vue.component('BackgroundLayer', BackgroundLayer)
Vue.component('TestimonySlider', TestimonySlider)
Vue.component('Video', Video)
Vue.component('Row', Row)
Vue.component('JourneyCarousel', JourneyCarousel)
Vue.component('JourneyCarouselItem', JourneyCarouselItem)
Vue.component('PinContainer', PinContainer)
Vue.component('PinCard', PinCard)
Vue.component('LicensingScrollSection', LicensingScroll)
Vue.component('ProductStepDiagram', ProductStepDiagram)
Vue.component('ShowCaseCarousel', ShowCaseCarousel)
Vue.component('CardSide', CardSide)
Vue.component('AvatarSimple', AvatarSimple)
Vue.component('OverFlowImage', OverFlowImage)
Vue.component('TabGroup', TabGroup)
Vue.component('VerticalTabGroup', VerticalTabGroup)
Vue.component('PricingComponent', PricingComponent)
Vue.component('CommunityNetwork', CommunityNetwork)
Vue.component('WellApHeroNetwork', WellApHeroNetwork)
Vue.component('CTA', CTA)
Vue.component('ParallaxImageWithIcons', ParallaxImageWithIcons)
Vue.component('VideoBackground', VideoBackground)
Vue.component('BrushArt', BrushArt)
Vue.component('Carousel', Carousel)
Vue.component('LogosTabGroup', LogosTabGroup)
Vue.component('EmailCapture', EmailCapture)
Vue.component('SectionLayout', SectionLayout)
Vue.component('BackgroundImage', BackgroundImage)
Vue.component('ResponsiveBackgroundImage', ResponsiveBackgroundImage)
Vue.component('CarouselCard', CarouselCard)
Vue.component('CarouselCardTab', CarouselCardTab)
Vue.component('ESGTriangleDiagram', ESGTriangleDiagram)
Vue.component('ESGStats', ESGStats)
Vue.component('ESGNetwork', ESGNetwork)
Vue.component('ESGCarousel', ESGCarousel)
Vue.component('CardNews', CardNews)
Vue.component('GridFeatured', GridFeatured)
Vue.component('ColumnLayout', ColumnLayout)
Vue.component('PollWidget', PollWidget)
Vue.component('SectionCopy', SectionCopy)
Vue.component('ImgWithText', NuxtImgWithText)
Vue.component('ESGBalanceIcons', ESGBalanceIcons)
Vue.component('ESGSeal', ESGSeal)
Vue.component('LeaderboardScores', LeaderboardScores)
Vue.component('LeaderboardMap', LeaderboardMap)
Vue.component('LeaderboardMapScore', LeaderboardMapScore)
Vue.component('CardLayout', CardLayout)
Vue.component('CardOrganization', CardOrganization)
Vue.component('LeaderboardAwardCollage', LeaderboardAwardCollage)
Vue.component('LeaderboardBarChart', LeaderboardBarChart)
Vue.component('RowLayout', RowLayout)
Vue.component('ExploreLayout', ExploreLayout)
Vue.component('CardBuilder', CardBuilder)
Vue.component('LeaderboardStrategiesTable', LeaderboardStrategiesTable)
Vue.component('LeaderboardTrends', LeaderboardTrends)
Vue.component('ImageLayout', ImageLayout)
Vue.component('SummitAspot', SummitAspot)
Vue.component('HbsptEmail', HbsptEmail)
Vue.component('Socials', Socials)
Vue.component('SummitTestimonyCarousel', SummitTestimonyCarousel)
Vue.component('Icon', Icon)
Vue.component('SliderLayout', SliderLayout)
Vue.component('HPBPollDiagram', HPBPollDiagram)
Vue.component('EPAspot', EPAspot)
Vue.component('RatingsAspot', RatingsAspot)
Vue.component('FacultyAspot', FacultyAspot)
Vue.component('ConferenceAspot', ConferenceAspot)
Vue.component('EquityRatingAspot', EquityRatingAspot)
Vue.component('ESGAspot', ESGAspot)
Vue.component('LeaderboardAspot', LeaderboardAspot)
Vue.component('HomeASpot', HomeASpot)
Vue.component('Orgs', Orgs)
Vue.component('Diagram', Diagram)
Vue.component('ESG', ESG)
Vue.component('HealthSafety', HealthSafety)
Vue.component('Projects', Projects)
Vue.component('Testimony', Testimony)
Vue.component('Media', Media)
Vue.component('Newsletter', Newsletter)
Vue.component('Science', Science)
Vue.component('HomeVideo', HomeVideo)
Vue.component('WellAtScaleASpot', WellAtScaleASpot)
Vue.component('Chart', Chart)
Vue.component('Performance', Performance)
Vue.component('Reports', Reports)
Vue.component('Roadmap', Roadmap)
Vue.component('Logos', Logos)
Vue.component('Solutions', Solutions)
Vue.component('FrequentlyAskedQuestions', FrequentlyAskedQuestions)
Vue.component('Connect', Connect)
Vue.component('Contact', Contact)
Vue.component('WhyWellASpot', WhyWellASpot)
Vue.component('Platform', Platform)
Vue.component('Results', Results)
Vue.component('Demand', Demand)
Vue.component('Leadership', Leadership)
Vue.component('Next', Next)

// new 2025
Vue.component('ChartModule', ChartModule)
